import { Clear as DeleteIcon } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  id: string;
  disabled?: boolean;
  handleToggle: (id: string) => void;
};

const ToggleButton = ({ id, disabled, handleToggle }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      startIcon={
        disabled ? (
          <CheckIcon sx={{ color: "#00000085" }} />
        ) : (
          <DeleteIcon sx={{ color: "#00000085" }} />
        )
      }
      onClick={() => handleToggle(id)}
    >
      <Typography color="textSecondary" fontSize="14px" whiteSpace="nowrap">
        {disabled ? t("customers:enable") : t("customers:disable")}
      </Typography>
    </Button>
  );
};

export default ToggleButton;
